module.exports = __webpack_public_path__ + "assets/img/first-screen-bg-3e0b4ca5.jpg";